<template>
  <div id="toast" class="show toast"><p class="msg">{{message}}</p></div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    }
  }
}
</script>

